import type { ReactNode } from 'react';
import _ from 'lodash';

export const NOTIFICATION_SEND = 'NOTIFICATION_SEND';
export const NOTIFICATION_DISMISS = 'NOTIFICATION_DISMISS';
export const NOTIFICATION_CLEAR = 'NOTIFICATION_CLEAR';

type NotificationPayload = {
  message: ReactNode | ((i18nData?: any) => ReactNode);
  id?: number | string;
  dismissAfter?: number;
  hideDismiss?: boolean;
  kind?: 'success' | 'error' | 'warning' | 'info' | 'danger';
};

export function notificationSend(notification: NotificationPayload): any {
  if (!notification.id) {
    notification.id = new Date().getTime();
  }

  return (dispatch: any) => {
    dispatch({ type: NOTIFICATION_SEND, payload: notification });

    if (notification.dismissAfter) {
      setTimeout(() => {
        dispatch({ type: NOTIFICATION_DISMISS, payload: notification.id });
      }, notification.dismissAfter);
    }
  };
}

/**
 * Send a notification that automatically dismisses after a specified time
 */
export const notificationSendDismiss =
  (notification: NotificationPayload): any =>
  (dispatch: any) => {
    dispatch(notificationSend(_.assign({}, { dismissAfter: notification.dismissAfter || 2000 }, notification)));
  };

export function notificationDismiss(id: number | string | undefined) {
  return {
    type: NOTIFICATION_DISMISS,
    payload: id,
  };
}

export function notificationClear() {
  return {
    type: NOTIFICATION_CLEAR,
  };
}
